/* eslint-disable complexity */
import { Termin } from '@/domain/termine/shared/types/Termin';
import { faEdit, faTrashCan } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Tooltip, TooltipContent, TooltipTrigger } from '@e2n/ui';
import { TerminInfo } from '@/domain/termine/features/Calendar/shared/TerminInfo/TerminInfo';
import { useDayPopover } from '@/domain/termine/features/Calendar/Grid/DayCell/Popover/DayPopoverContext';
import { Link, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

// eslint-disable-next-line max-lines-per-function
export function TerminPopoverContent({
  termin,
  onDeleteClick,
}: {
  termin: Termin;
  onDeleteClick: () => void;
}) {
  const fromDayPopover = useDayPopover();
  const { t } = useTranslation();
  const { year, month } = useParams();

  const isDeleteDisabled =
    termin.arbeitszeiten.length > 0 ||
    termin.schichten.length > 0 ||
    termin?.hasHiddenSchichten ||
    termin?.hasHiddenArbeitszeiten;

  return (
    <div
      className={`w-[340px] bg-white shadow-lg p-5 rounded-lg ${
        fromDayPopover ? 'translate-x-[15px]' : ''
      }`}>
      <TerminInfo termin={termin} />
      <div className="flex justify-end items-center gap-3 mt-5">
        <Tooltip>
          <TooltipTrigger asChild>
            <span>
              <Button
                size="sm"
                variant="ghost"
                onClick={onDeleteClick}
                disabled={isDeleteDisabled}>
                <FontAwesomeIcon
                  className={
                    isDeleteDisabled
                      ? 'text-neutrals-400'
                      : 'text-primary-red-400'
                  }
                  icon={faTrashCan}
                />
              </Button>
            </span>
          </TooltipTrigger>
          {isDeleteDisabled && (
            <TooltipContent className="whitespace-pre-line">
              {t('domain.termine.deleteWithHiddenArbeitsbereich')}
            </TooltipContent>
          )}
        </Tooltip>
        <Button asChild size="sm" variant="ghost">
          <Link
            to={`/termine/uebersicht/${year}/${month}/edit/${termin.id}`}
            state={{ datum: termin.datum }}>
            <FontAwesomeIcon className="text-primary-blue-600" icon={faEdit} />
          </Link>
        </Button>
      </div>
    </div>
  );
}
